import { Box, Typography } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import { SaveFilled } from "@ant-design/icons";
import styles from './FormLayout.module.scss';

export const FormLayout = ({ children, onSaveClick, saving, disableButton }) => {

    const handleSubmit = e => {
        e.preventDefault();
        onSaveClick(e.currentTarget);
    }

    const styleButton = {
        boxShadow: "1px 1px 5px 2px rgba(0, 0, 0, 0.3)",
        borderRadius: '4px',
        backgroundColor: 'green',
        marginTop: '20px',
        marginBottom: '5px',
    }

    return (
        <Box
            component="form"
            onSubmit={e => handleSubmit(e)}
            sx={{
                mt: -3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'

            }}>

            <Box >
                {children}
            </Box>
            <Typography variant="caption" gutterBottom sx={{ display: 'block', marginTop: '5px' }}>Os campos marcados com * são de preenchimento obrigatório.</Typography>
            <div className={styles.saveBtn}>
                <LoadingButton
                    disabled={disableButton}
                    loading={saving}
                    variant="contained"
                    endIcon={<SaveFilled />}
                    type="submit"

                    style={styleButton}
                >
                    Salvar
                </LoadingButton>
            </div>
        </Box>
    );
};